/**
 * @flow
 */

import { decodeString } from "./decode";

/**
 * Parses the incoming CMS content from the server.
 * @param rawCMSContent - The incoming CMS content to be parsed.
 * @returns {string} - The parsed CMS content. Returns an empty string if there was no content to be parsed.
 */
export function parseCMSContentFromString(rawCMSContent: string): string {
  const parser: DOMParser = new DOMParser();
  const parsedHTMLDocument: Document = parser.parseFromString(decodeString(rawCMSContent), "text/html");
  // DOMParser.parseFromString() generates a Document whose HTML element is complete with html, head, and body.
  // Extract the CMS content which is inside the HTML element's body.
  let parsedCMSContent: string = "";
  if (parsedHTMLDocument && parsedHTMLDocument.body && parsedHTMLDocument.body.innerHTML) {
    parsedCMSContent = parsedHTMLDocument.body.innerHTML;
  }
  return parsedCMSContent;
}

/**
 * Parses an encoded string. Ex. "&amp;" -> "&"
 * @param encodedText
 * @returns {string}
 */
export function parseEncodedTextFromString(encodedText: ?string): string {
  const parser: DOMParser = new DOMParser();
  const parsedHTMLDocument: Document = parser.parseFromString(encodedText ?? "", "text/html");
  return parsedHTMLDocument.documentElement?.textContent ?? "";
}
